import React from 'react';
import CardVODSearch from './CardVODSearch';
import CardEventLiveSearch from './CardEventLiveSearch';
import CardTalentSearch from './CardTalentSearch';
import SearchConstants from '../SearchConstants';
import CardSerieSearch from './CardSerieSearch';
import CardChannelSearch from './CardChannelSearch';
import CardRecordingSearch from './CardRecordingSearch';
import { AAFPLAYER_PLAY } from '../../../AAFPlayer/constants';
import Translator from '../../../requests/apa/Translator';
import ReminderNotifications from '../../../utils/RemindersNotifications/ReminderNotifications';
import PlayerStreamingUtils from '../../../utils/PlayerStreamingUtils';
import ChannelSingleton from '../../../components/Epg/ChannelsSingleton';
import Utils from '../../../utils/Utils';
import { NPVR_RECORDED_STATUS } from '../../../AAF/Npvr/Constans';
import NpvrUploader from '../../../AAF/Npvr/NpvrUploader';
import { id } from 'date-fns/locale';
import UtilsSearch from '../UtilsSearch';

const CardByElement = ({ onFocus = null, item =null, bookmark=[], contentPlay ={},  changeRoute= null, playFullMedia = null, user = null, contentsearch = null}) => {

    const changeRouteMovieSerie = (groupId) =>{
        const path = `/vcard/${groupId}`;
        changeRoute && (typeof changeRoute === 'function') && changeRoute(path);
    }


    const sentToPlaySerieVod = (groupID) =>{
        const Params = {
            playerstate: AAFPLAYER_PLAY,
            source: {
              videoid: groupID
            },
            ispreview: false,
            islive: false,
            ispip: false,
            ischangeepisode:true,
        };
        // changeRouteMovieSerie(groupID);
        playFullMedia && (typeof playFullMedia === 'function') && playFullMedia(Params);
    }

    const getTextButtons = (text) =>{
        switch(text){
            case SearchConstants.BUTTON_MORE_INFO:
                return Translator.get('content_data_option_button_vcard','MÁS INFO');
            default:
                return text;
        }
    }

    const isReminder = (event) =>{
        if (event && event.id && ReminderNotifications.hasEventReminder(event.id)) {
            return true;
        }
        return false;
    }


    const handleRecordingPlay = (data) => {
        const {actions = null} = data;
        // ESTA LOGICA ES DE MIS CONTENDISO
        if (actions && actions.play && actions.play !== '') {
          const pgmUrl = actions.play.smooth_streaming;
          const params = {
            playerstate: AAFPLAYER_PLAY,
            source: {
              //videoid: 764423
              videosource: pgmUrl
            },
            size: {
              top: 0,
              left: 0,
              width: 1280,
              height: 720
            },
            ispreview: false,
            islive: false,
            ispip: false,
            videosourceoptions: actions.play,
            event: null,
            npvrEvent: data
          };
          playFullMedia && (typeof playFullMedia === 'function') && playFullMedia(params);
        }
      };

     const sendPlayLive = (item, fromCardchannel = false) => {
         let group_id = null;
         if(fromCardchannel){
            group_id = item;
         }else{
            const {channel_group = {}, id:groupId = null} = item;
            group_id = channel_group && channel_group.common ? channel_group.common.id : groupId;
         }

        const params = {
            playerstate: AAFPLAYER_PLAY,
            source: {
                videoid: group_id,
            },
            size: {
                top: 0,
                left: 0,
                width: 1280,
                height: 720,
            },
            ispreview: false,
            islive: true,
            ispip: false,
            event: null,
        };
        group_id && playFullMedia && (typeof playFullMedia === 'function') && playFullMedia(params);
    };

    const isPlayElement = (item, type, contentsearch) =>{
        // SI ES EVENTO SE BUSCA POR GROUPID SI NO POR ID
        let itemFind = null;
        if (type && type === SearchConstants.EVENT) {

          const {group_id = null} = item || {};
          return group_id && ChannelSingleton.canPlayChannel(group_id);

        } else if (type && type === SearchConstants.CHANNEL) {

            const { id = null } = item || {};
            return id && ChannelSingleton.canPlayChannel(id);

        }else if(type && contentsearch.length > 0 && (type === SearchConstants.MOVIE || type === SearchConstants.SERIE) ){

            const element = contentsearch.find(content => content.includes(item.id)) || [];
            const haveElementsVisible = element && element.length > 0;
            const visible = haveElementsVisible ? element[1] : null;

            if(visible && visible.visibleFremium){
              visible.visible = visible.visibleFremium;
            }

            return haveElementsVisible ? visible.visible : false;

        }else{
            const {id = null} = item || {};
            if(contentPlay[id]){
                itemFind =contentPlay[id];
            }
            return isPurchased(itemFind);
        }

    }

    const isPurchased = (item) => {
        const havePlayButton = item && item.playButton
        && item.playButton.waspurchased && item.playButton.waspurchased === '1';

        const havePlayFreemiumButton = item && item.playFreemiumButton
        && item.playFreemiumButton.waspurchased && item.playFreemiumButton.waspurchased === '1';

        return havePlayFreemiumButton || havePlayButton;
    }

    const sentToPurchase = async (group_id) =>{
        const playerStreamingUtils = new PlayerStreamingUtils();
        const isSusc = await playerStreamingUtils.checkSusc(null,group_id,() =>{});
    }

    const status =  NpvrUploader.getAllRecordingStatusByEventId(item.event_alf_id);



    switch(item.content_type){
        //EL TIPO DE CONTENIDO ES UNA PELICULA
        case SearchConstants.MOVIE:
            return <CardVODSearch onFocus = {onFocus}  item={item} changeRoute={changeRouteMovieSerie} bookmark={bookmark} sentToPlaySerieVod={sentToPlaySerieVod} user={user} getTextButtons={getTextButtons} isPlay={isPlayElement(item, item.content_type, contentsearch)} contentsearch = {contentsearch}/>;
        //EL TIPO DE CONTENIDO ES UNA SERIE
        case SearchConstants.SERIE:
            return <CardSerieSearch onFocus = {onFocus} item={item} changeRoute={changeRouteMovieSerie} bookmark={bookmark} sentToPlaySerieVod={sentToPlaySerieVod} user={user} getTextButtons={getTextButtons} isPlay={isPlayElement(item, item.content_type, contentsearch)} contentsearch = {contentsearch}/>;
        case SearchConstants.EVENT:
        //EL TIPO DE CONTENIDO ES UN EVENTO LIVE
            return status && (status.recording_status === NPVR_RECORDED_STATUS)
            ? <CardRecordingSearch onFocus = {onFocus} item={item} handleRecordingPlay={handleRecordingPlay}  isReminder={isReminder(item)} showModalOptions={UtilsSearch.showModalOptions} sendPlayLive={sendPlayLive} contentsearch = {contentsearch}/>
            : <CardEventLiveSearch  onFocus = {onFocus} item={item} sendPlayLive={sendPlayLive} user={user} isReminder={isReminder(item)} showModalOptions={UtilsSearch.showModalOptions} isPlay={isPlayElement(item, item.content_type)} sentToPurchase={sentToPurchase} contentsearch = {contentsearch}/>
        //SI ES UNA GRABACION
        case SearchConstants.RECORDING:
            return <CardRecordingSearch onFocus = {onFocus} item={item} handleRecordingPlay={handleRecordingPlay}  isReminder={isReminder(item)} showModalOptions={UtilsSearch.showModalOptions} sendPlayLive={sendPlayLive} contentsearch = {contentsearch}/>
        case SearchConstants.TALENT:
            return <CardTalentSearch onFocus = {onFocus} item={item} user={user} changeRoute={changeRouteMovieSerie} getTextButtons={getTextButtons} contentsearch = {contentsearch}/>
        case SearchConstants.CHANNEL:
            return item.actual_event
            ? <CardEventLiveSearch  onFocus = {onFocus} item={item} sendPlayLive={sendPlayLive} user={user} isReminder={isReminder(item)} isPlay={isPlayElement(item, item.content_type)} sentToPurchase={sentToPurchase}/>
            : <CardChannelSearch onFocus = {onFocus}item={item} changeRoute={changeRouteMovieSerie} bookmark={bookmark} sendPlayLive={sendPlayLive} user={user} getTextButtons={getTextButtons} isPlay={isPlayElement(item, item.content_type)}  sentToPurchase={sentToPurchase} contentsearch = {contentsearch}/>;
        default:
            return <CardVODSearch onFocus = {onFocus} item={item} changeRoute={changeRouteMovieSerie} bookmark={bookmark} sentToPlaySerieVod={sentToPlaySerieVod} user={user} getTextButtons={getTextButtons} isPlay={isPlayElement(item, item.content_type, contentsearch)} contentsearch = {contentsearch} />;
    }
};

export default CardByElement;



// WEBPACK FOOTER //
// ./src/containers/Search/components/CardByElement.jsx